/**
 * An object containing properties for list events
 */
export class ListEvent {
  /**
   * The object associated with the current row
   */
  item: any;

  /**
   * The currently selected items, if applicable
   */
  selectedItems?: any[];
}
